import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Accounts_Customizations_Object} state
 *  @property {object} model
 *  @property {Accounts_Customizations_Properties} model.properties
 *  @property {Accounts_Customizations_Is} model.is
 *  @property {Accounts_Customizations_Has} model.has
 */
export default class AccountCustomizationsPassword extends ObjectOverride {
	constructor(props) {
		super(props, Types.Accounts_Customizations._name, API.RequestType.READ);
		this.update = API.RequestType.UPDATE;
	}

	form = () => {
		/** @type {Accounts_Customizations_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Customizations_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Column 1*/}
						<div className={"col-md"}>
							<div className="row">
								<div className="col-6">
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.password_min_length}
											value={object.password_min_length}
											error={object.password_max_length_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className="col-6" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.password_max_length}
											value={object.password_max_length}
											error={object.password_max_length_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>


							<div className="row">
								<div className="col-9">
									<span className="input-label">Must Contain Upper & Lower</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_upper_and_lower}
											value={object.password_upper_and_lower}
											error={object.password_upper_and_lower_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-9">
									<span className="input-label">Must Contain Numeric</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_numeric}
											value={object.password_numeric}
											error={object.password_numeric_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-9">
									<span className="input-label">Must Contain Special Character</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_special}
											value={object.password_special}
											error={object.password_special_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-9">
									<span className="input-label">No Repeating Characters</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_no_repeats}
											value={object.password_no_repeats}
											error={object.password_no_repeats_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-9">
									<span className="input-label">No Common Words</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_no_common_words}
											value={object.password_no_common_words}
											error={object.password_no_common_words_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-9">
									<span className="input-label">Require Password Rotation</span>
								</div>
								<div className="col-3" style={{textAlign: "right"}}>
									<div className="form-group">
										<Framework.Elements.ButtonSwitch
											property={properties.password_expiration}
											value={object.password_expiration}
											error={object.password_expiration_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>

						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
